var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 117,
    viewBox: "0 0 115 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 54.15,
    height: 54.15,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 34.3636C12.0684 34.3636 13.6894 37.0508 15.1694 37.0508C16.6494 37.0508 20.1444 23.934 21.7591 23.934C23.3738 23.934 26.708 34.3636 28.2713 34.3636C29.8345 34.3636 32.9234 15.6758 34.9385 15.6758C37.3009 15.6758 39.5782 27.1366 41.9934 27.1366",
    stroke: "#63658E",
    strokeWidth: 1.425
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5176,
    width: 54.15,
    height: 54.15,
    rx: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.918 34.3636C71.918 34.3636 73.539 37.0508 75.019 37.0508C76.499 37.0508 79.994 23.934 81.6087 23.934C83.2234 23.934 86.5576 34.3636 88.1209 34.3636C89.6841 34.3636 92.773 15.6758 94.7881 15.6758C97.1505 15.6758 99.4279 27.1366 101.843 27.1366",
    stroke: "#63658E",
    strokeWidth: 1.425
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    y: 62.1484,
    width: 54.15,
    height: 54.15,
    rx: 4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 96.512C12.0684 96.512 13.6894 99.1992 15.1694 99.1992C16.6494 99.1992 20.1444 86.0825 21.7591 86.0825C23.3738 86.0825 26.708 96.512 28.2713 96.512C29.8345 96.512 32.9234 77.8242 34.9385 77.8242C37.3009 77.8242 39.5782 89.2851 41.9934 89.2851",
    stroke: "#63658E",
    strokeWidth: 1.425
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5176,
    y: 62.1484,
    width: 54.15,
    height: 54.15,
    rx: 4,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.918 96.512C71.918 96.512 73.539 99.1992 75.019 99.1992C76.499 99.1992 79.994 86.0825 81.6087 86.0825C83.2234 86.0825 86.5576 96.512 88.1209 96.512C89.6841 96.512 92.773 77.8242 94.7881 77.8242C97.1505 77.8242 99.4279 89.2851 101.843 89.2851",
    stroke: "#63658E",
    strokeWidth: 1.425
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.af59500164b16558009af4539a4623a5.svg";
export { ForwardRef as ReactComponent };